import './newsletters.styles';

import Pristine from 'pristinejs';

import { NEWSLETTERS_TEXTS } from '@/scripts/common/textMsg';
import SpinBtn from '@/components/SpinBtn';

/** @param {HTMLElement} parent */
export default function initNewsletters(parent) {
   const $root = parent.querySelector('.newsletters-js');
   const $form = $root.querySelector('.newsletters-form-js');
   const $submitBtn = $form.querySelector('.newsletters-submit-js');
   const $error = $form.querySelector('.newsletters-error-js');
   const $themes = [...$form.themes];

   const submitBtn = new SpinBtn($submitBtn, { checkIcon: false });

   const validator = new Pristine($form, {
      classTo: 'newsletters-js',
      errorClass: 'newsletters__error',
      errorTextParent: 'newsletters-error-js',
   });

   initEvents();

   function initEvents() {
      $form.addEventListener('submit', (e) => {
         e.preventDefault();
         if (validator.validate()) submit();
      });
   }

   function submit() {
      const email = $form.email.value.trim();
      const themes = getThemes();

      if (!themes.length) {
         showError(NEWSLETTERS_TEXTS.MinCategories);
         return;
      }

      submitBtn.startLoading();
      hideError();

      if (!window.humTracker) {
         submitBtn.stopLoading(false);
         return;
      }

      setTimeout(async () => {
         await submitBtn.stopLoading(true);
         showSuccess();
      }, 500);
   }

   function getThemes() {
      return $themes.filter($ => $.checked).map($ => $.value);
   }

   function showError(error) {
      $root.classList.add('newsletters__error');
      $error.innerHTML = error;
   }

   function hideError() {
      $root.classList.remove('newsletters__error');
   }

   function showSuccess() {
      $root.classList.add('newsletters__success');
   }
}